import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "style", "as", "asChild", "children", "size", "initials", "color", "tooltipContent", "buttonProps"];
import React from "react";
import ConditionalTooltipWrapper from "../helpers/components/ConditionalTooltipWrapper";
import Avatar from "./Avatar";
import { BaseAvatarButton } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var AvatarButton = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var className = _ref.className,
    style = _ref.style,
    as = _ref.as,
    asChild = _ref.asChild,
    children = _ref.children,
    size = _ref.size,
    initials = _ref.initials,
    color = _ref.color,
    tooltipContent = _ref.tooltipContent,
    buttonProps = _ref.buttonProps,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsx(BaseAvatarButton, _extends({
      ref: forwardedRef
    }, buttonProps, rest, {
      children: /*#__PURE__*/_jsx(Avatar, {
        size: size,
        initials: initials,
        color: color
      })
    }))
  });
});
AvatarButton.displayName = "AvatarButton";
export default AvatarButton;